import { TRepoKey } from '~/components/FlowGallery/types/flow-gallery.types';
import {
    RepositoryOption,
    TTagsProperty
} from '~/components/GalleryDashboard/gallery-dashboard.types';

export const REPOSITORY_LABELS: Record<TRepoKey, string> = {
    prepublish_templates: 'Prepublish',
    internal_templates: 'Internal',
    flow_gallery: 'Public'
};

export const REPOSITORY_OPTIONS: RepositoryOption[] = [
    {
        label: REPOSITORY_LABELS.prepublish_templates,
        value: 'prepublish_templates'
    },
    {
        label: REPOSITORY_LABELS.internal_templates,
        value: 'internal_templates'
    },
    {
        label: REPOSITORY_LABELS.flow_gallery,
        value: 'flow_gallery'
    }
];

export const UPLOAD_THUMBNAIL_MODAL_CSS_CLASS =
    'gallery-dashboard-thumbnail-modal';

export const UPLOAD_THUMBNAIL_MODAL_TITLE = 'Edit thumbnail';

export const ALL_TAGS_VALUES: Record<TTagsProperty, string> = {
    tags: 'all_tags',
    system_attributes: 'all_system_tags'
};
